import { env } from "@/config";
import * as Sentry from "@sentry/react";

const ENVIRONMENTS_MAP = {
  DEV: {
    environment: "local",
    enabled: false,
  },

  QA: {
    environment: "qa",
    _experiments: {
      profilesSampleRate: 1,
    },
  },

  // will not be used for now, staging is promoted to prod so
  // we will use prod envs
  INTERNAL: {
    environment: "internal",
    _experiments: {
      profilesSampleRate: 1,
    },
  },

  PROD: {
    environment: "production",
    // _experiments: {
    //   profilesSampleRate: 1.0,
    // },
  },
};

// In case we didn't set this we default to prod so at least it will work on prod
const configByEnv = ENVIRONMENTS_MAP[env.env] ?? (env.isDev ? ENVIRONMENTS_MAP.PROD : undefined);

Sentry.init({
  dsn: env.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({}),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        //eslint-disable-next-line
        "^https:\/\/(?:\w+\.)?(?:[^\/]+)\.(?:\w{2,})(?:\/api)?\/(?:v2|api\/v3)$"
      ],
      networkRequestHeaders: ['X-Custom-Header', 'x-device-id', 'Authorization', 'Content-Type', 'User-Agent', 'Accept'],
      networkResponseHeaders: ['X-Custom-Header', 'Content-Type'],
    }),
  ],
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  tracesSampleRate: 1,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  ...configByEnv,
});

if (window.session_id) {
  Sentry.setUser({
    id: window.session_id
  });
}
